export default "__VITE_ASSET__51dbd2a9__"